<p-fileUpload
  name="myfile[]"
  (onSelect)="selectFiles($event)"
  [customUpload]="true"
  (uploadHandler)="readAsJson()"
  [multiple]="false"
  accept=".xlsx, .xls"
>
  <ng-template pTemplate="toolbar"> </ng-template>
  <ng-template let-file pTemplate="file">
    <div class="p-fileupload-row ng-star-inserted">
      <div class="p-fileupload-filename">
        {{ file.name }}
      </div>
      <div>{{ file.size / 1000 }} KB</div>
    </div>
  </ng-template>
  <ng-template pTemplate="content" let-files>
    <div class="mt-2" *ngIf="uploadedFiles.length === 0">
      <p-button label="Download Sample Excel File" styleClass="p-button-link" (click)="downloadSampleFile()"></p-button>
    </div>
  </ng-template>
</p-fileUpload>
